/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexampleretouchprompt3Inputs */

const en_refineexampleretouchprompt3 = /** @type {(inputs: Refineexampleretouchprompt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retouch spots and scratches in the image`)
};

const de_refineexampleretouchprompt3 = /** @type {(inputs: Refineexampleretouchprompt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retuschiere Flecken und Kratzer im Bild`)
};

/**
* | output |
* | --- |
* | "Retouch spots and scratches in the image" |
*
* @param {Refineexampleretouchprompt3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexampleretouchprompt3 = /** @type {((inputs?: Refineexampleretouchprompt3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexampleretouchprompt3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexampleretouchprompt3(inputs)
	return de_refineexampleretouchprompt3(inputs)
});
export { refineexampleretouchprompt3 as "refineExampleRetouchPrompt" }